import { Link } from "react-router-dom";
import { Button } from "@/components/Base/Button";

export const LoginHeader = () => {
  return (
    <Link to={"/register"}>
      <Button className="text-base" variant="ghost-primary">
        Sign Up
      </Button>
    </Link>
  );
};
